import { render, staticRenderFns } from "./ExciseTaxRateToSpecialDistrictDialog.vue?vue&type=template&id=2070ae97&"
import script from "./ExciseTaxRateToSpecialDistrictDialog.vue?vue&type=script&lang=js&"
export * from "./ExciseTaxRateToSpecialDistrictDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports